import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-validators',
  templateUrl: './validators.component.html',
  styleUrls: ['./validators.component.css']
})

export class ValidatorsComponent {
  first = 0;
}
